import { render, staticRenderFns } from "./InternalProcess.vue?vue&type=template&id=6470a855"
import script from "./InternalProcess.vue?vue&type=script&lang=js"
export * from "./InternalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6470a855')) {
      api.createRecord('6470a855', component.options)
    } else {
      api.reload('6470a855', component.options)
    }
    module.hot.accept("./InternalProcess.vue?vue&type=template&id=6470a855", function () {
      api.rerender('6470a855', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/InternalProcess.vue"
export default component.exports